import { trackUserProperty } from "@/analytics/track";
import { i18n, setLocale } from "@/translations/i18n";
import { addFontFamily } from "@/utils/dom/dom";

export async function setLanguage(lang: string) {
  trackUserProperty("language", lang);
  if (lang === "ja") {
    addFontFamily(document.documentElement, "Noto Sans JP");
  }
  await setI18nLanguage(lang);
}

const loadedLanguages = ["en", "none"];

async function setI18nLanguage(lang: string) {
  try {
    if (i18n.global.locale.value !== lang && !loadedLanguages.includes(lang)) {
      const messages = await import(`./translations/${lang}.json`);
      i18n.global.setLocaleMessage(lang, messages.default);
      loadedLanguages.push(lang);
    }
    setLocale(lang);
    document.querySelector("html")?.setAttribute("lang", lang);
  } catch (_) {
    // ignore when loading messages goes wrong
  }
}
